import { render, staticRenderFns } from "./text-area.html?vue&type=template&id=3de64d23&scoped=true&"
import script from "./text-area.js?vue&type=script&lang=js&"
export * from "./text-area.js?vue&type=script&lang=js&"
import style0 from "./text-area.scss?vue&type=style&index=0&id=3de64d23&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de64d23",
  null
  
)

export default component.exports